import { createAction, handleActions, Action } from 'redux-actions'
import { FETCH_COURSES_SUCCESS } from '../../sagas/gradPlanner/gradPlannerSaga'
import { subjectAreas } from 'tmw-validation'
import {
  getValidator,
  setValidatorCourses
} from '../../../services/courseValidation'
import {
  SET_GRADPLANNER_DIRTY,
  CHANGE_CURRENT_STEP,
  CHANGE_REQUIRED_PAGE,
  CHANGE_CAREER_PATH_REQUIRED_PAGE,
  CHANGE_ELECTIVE_PAGE,
  CHANGE_PLAN,
  CHANGE_DISTRICT,
  CHANGE_SCHOOL,
  CHANGE_ENDORSEMENT,
  CHANGE_CAREER_PATH,
  ADD_CORE_CLASS,
  REMOVE_CORE_CLASS,
  ADD_CAREER_PATH_REQUIRED_CLASS,
  REMOVE_CAREER_PATH_REQUIRED_CLASS,
  ADD_ELECTIVE_CLASS,
  REMOVE_ELECTIVE_CLASS,
  RESET,
  SET_SAVED_PLAN,
  SET_SUB_STATE,
  CLEAR_SUB_STATES,
  TOGGLE_DISPLAY_REVIEW,
  actions as myActions,
  actionCreators as myActionCreators
} from './gradPlannerActions'
import { createSelector } from 'reselect'
export const actions = myActions
export const actionCreators = myActionCreators
type School = {
  name: string,
  id: string,
  code: number,
  mou: boolean,
  mou_last_updated: string
}

type GradPlannerPlan = {
  isDirty: boolean,
  district: string,
  allowBack: boolean,
  school: School,
  endorsement: string,
  careerPath: string,
  coreCourses: Array<string>,
  requiredCourses: Array<string>,
  electiveCourses: Array<string>,
  subStates: Object
}

export type GradPlannerState = {
  isDirty: boolean,
  currentStep: number,
  requiredPage: number,
  careerPathRequiredPage: number,
  electivePage: number,
  plan: GradPlannerPlan,
  savedPlan: GradPlannerPlan,
  courses: Array<>,
  schoolOfferings: Object,
  subStates: Object
}

export const initialState: GradPlannerState = {
  isDirty: false,
  currentStep: 0,
  requiredPage: 0,
  careerPathRequiredPage: 0,
  electivePage: 0,
  plan: {
    isDirty: false,
    allowBack: true,
    district: '',
    school: '',
    isCharterSchool: false,
    isSuspendSchool: false,
    endorsement: '',
    careerPath: '',
    coreCourses: [],
    requiredCourses: [],
    electiveCourses: [],
    subStates: {}
  },
  savedPlan: '',
  courses: [],
  schoolOfferings: setValidatorCourses([]).schoolOfferings,

  displayReview: false
}

export default handleActions(
  {
    [SET_GRADPLANNER_DIRTY]: (state, action: Action<boolean>) => ({
      ...state,
      isDirty: action.payload
    }),
    [CHANGE_CURRENT_STEP]: (state, action: Action<number>) => ({
      ...state,
      currentStep: action.payload,
      isDirty: true
    }),
    [CHANGE_REQUIRED_PAGE]: (state, action: Action<number>) => ({
      ...state,
      requiredPage: action.payload
    }),
    [CHANGE_CAREER_PATH_REQUIRED_PAGE]: (state, action: Action<number>) => ({
      ...state,
      careerPathRequiredPage: action.payload
    }),
    [CHANGE_ELECTIVE_PAGE]: (state, action: Action<number>) => ({
      ...state,
      electivePage: action.payload
    }),
    [CHANGE_PLAN]: (state, action: Action<GradPlannerPlan>) => ({
      ...state,
      plan: { ...state.plan, ...action.payload }
    }),
    [CHANGE_DISTRICT]: (state, action: Action<string>) => ({
      ...state,
      plan: {
        ...state.plan,
        district: action.payload
      }
    }),
    [CHANGE_SCHOOL]: (state, action: Action<School>) => ({
      ...state,
      plan: {
        ...state.plan,
        school: action.payload
      }
    }),
    [CHANGE_ENDORSEMENT]: (state, action: Action<string>) => ({
      ...state,
      plan: {
        ...state.plan,
        endorsement: action.payload,
        careerPath: ''
      }
    }),
    [CHANGE_CAREER_PATH]: (state, action: Action<string>) => ({
      ...state,
      plan: {
        ...state.plan,
        careerPath: action.payload
      }
    }),
    [ADD_CORE_CLASS]: (state, action: Action<string>) => {
      let coreCourses = [...state.plan.coreCourses, action.payload]
      return {
        ...state,
        plan: {
          ...state.plan,
          coreCourses
        }
      }
    },
    [REMOVE_CORE_CLASS]: (state, action: Action<string>) => {
      return {
        ...state,
        plan: {
          ...state.plan,
          coreCourses: [
            ...state.plan.coreCourses.filter(c => c.id !== action.payload.id)
          ]
        }
      }
    },
    [ADD_CAREER_PATH_REQUIRED_CLASS]: (state, action: Action<string>) => {
      return {
        ...state,
        plan: {
          ...state.plan,
          requiredCourses: [...state.plan.requiredCourses, action.payload]
        }
      }
    },
    [REMOVE_CAREER_PATH_REQUIRED_CLASS]: (state, action: Action<string>) => {
      return {
        ...state,
        plan: {
          ...state.plan,
          requiredCourses: state.plan.requiredCourses.filter(
            c => c.id !== action.payload.id
          )
        }
      }
    },
    [ADD_ELECTIVE_CLASS]: (state, action: Action<string>) => {
      return {
        ...state,
        plan: {
          ...state.plan,
          electiveCourses: [...state.plan.electiveCourses, action.payload]
        }
      }
    },
    [REMOVE_ELECTIVE_CLASS]: (state, action: Action<string>) => {
      return {
        ...state,
        plan: {
          ...state.plan,
          electiveCourses: state.plan.electiveCourses.filter(
            c => c.id !== action.payload.id
          )
        }
      }
    },
    [FETCH_COURSES_SUCCESS]: (state, action: Action<Array>) => {
      const schoolOfferings = setValidatorCourses(action.payload)
      return {
        ...state,
        courses: action.payload,
        coursesAvailableForCore: action.payload,
        coursesAvailableForElectives: action.payload,
        schoolOfferings: schoolOfferings.schoolOfferings,
        plan: {
          ...state.plan,
          subStates: initialState.plan.subStates
        }
      }
    },
    [RESET]: () => initialState,
    [SET_SAVED_PLAN]: (state, action: Action<GradPlannerPlan>) => ({
      ...state,
      savedPlan: action.payload
    }),
    [SET_SUB_STATE]: (state, action) => ({
      ...state,
      plan: {
        ...state.plan,
        subStates: {
          ...state.plan.subStates,
          [action.payload.key]: action.payload.payload
        }
      }
    }),
    [CLEAR_SUB_STATES]: (state, action) => ({
      ...state,
      plan: { ...state.plan, subStates: initialState.plan.subStates }
    }),
    [TOGGLE_DISPLAY_REVIEW]: (state, action) => ({
      ...state,
      displayReview: !state.displayReview
    })
  },
  initialState
)
export const cleanEndorsementName = endorsement => {
  switch (endorsement) {
    case 'businessAndIndustry':
      return 'businessIndustry'
    case 'publicServices':
      return 'publicService'
    case 'artsAndHumanities':
      return 'artsHumanities'
    default:
      return endorsement
  }
}

const toKeyValuePair = obj => key => ({ key, value: obj[key] })
const hasPassingPath = offering => {
  const careerPathOptions = Object.values(offering.value)
  return careerPathOptions.find((careerPathOption, index) => {
    return careerPathOption.validation.pass
  })
}
export const findEndorsements = schoolOfferings => {
  const localSchoolOfferings = { ...schoolOfferings }
  delete localSchoolOfferings.core
  delete localSchoolOfferings.endorsementBaseMath
  delete localSchoolOfferings.endorsementBaseScience
  return Object.keys(localSchoolOfferings)
    .map(toKeyValuePair(localSchoolOfferings))
    .filter(hasPassingPath)
    .map(offering => offering.key)
}

export const findCareerPaths = (schoolOfferings, endorsement) => {
  const keyArray =
    schoolOfferings[endorsement] &&
    Object.keys(schoolOfferings[endorsement])
      .map(toKeyValuePair(schoolOfferings[endorsement]))
      .filter(offering => offering.value.validation.pass)
      .map(offering => offering.key)
  if (endorsement === 'businessAndIndustry') {
    let cteOptions = [
      'agriculture',
      'architectureConstruction',
      'artsTechCom',
      'businessManagementAndAdministration',
      'finance',
      'hospitalityAndTourism',
      'informationTechnology',
      'manufacturing',
      'marketing',
      'transportationDistributionAndLogistics'
    ]
    const validBusinessOptions = ['english', 'technologyApplications']

    return keyArray
      .filter(key => validBusinessOptions.includes(key))
      .concat(cteOptions)
  } else if (endorsement === 'publicServices') {
    let cteOptions = [
      'law',
      'publicSafety',
      'correctionsAndSecurity',
      'educationAndTraining',
      'governmentAndPublicAdministration',
      'healthScience',
      'humanServices'
    ]
    const validOptions = ['JROTC']
    return keyArray.filter(key => validOptions.includes(key)).concat(cteOptions)
  } else if (endorsement === 'stem') {
    let cteOptions = ['cte']

    return keyArray.concat(cteOptions)
  }
  return keyArray
}

const cteOptions = [
  'agriculture',
  'architectureConstruction',
  'artsTechCom',
  'businessManagementAndAdministration',
  'finance',
  'hospitalityAndTourism',
  'informationTechnology',
  'manufacturing',
  'marketing',
  'transportationDistributionAndLogistics',
  'law',
  'publicSafety',
  'correctionsAndSecurity',
  'educationAndTraining',
  'governmentAndPublicAdministration',
  'healthScience',
  'humanServices',
  'cte'
]

export const getCareerPathOffering = (schoolOfferings, plan) => {
  if (
    plan.endorsement !== '' &&
    plan.careerPath !== '' &&
    !cteOptions.includes(plan.careerPath)
  ) {
    const relatedCareerPathOffering =
      schoolOfferings[plan.endorsement][plan.careerPath]
    delete relatedCareerPathOffering.validation
    return relatedCareerPathOffering
  } else {
    return { options: { courses: [] } }
  }
}

export const getElectives = schoolOfferings => {
  let electives = schoolOfferings.core.options.electiveOptions.courses
  return subjectAreas.map(subjectArea => {
    const relatedElectives = electives.filter(elective => {
      return elective.subject_area_code === parseInt(subjectArea.id, 10)
    })
    return {
      name: subjectArea.name,
      courses: relatedElectives,
      creditsRequired:
        schoolOfferings.core.options.electiveOptions.creditsRequired
    }
  })
}

// selectors
const selectCourses = (state: { gradPlanner: GradPlannerState }) => {
  return state.gradPlanner.courses
}

const selectCoreCourses = (state: { gradPlanner: GradPlannerState }) =>
  state.gradPlanner.plan.coreCourses
const selectPathCourses = (state: { gradPlanner: GradPlannerState }) =>
  state.gradPlanner.plan.requiredCourses
const selectElectiveCourses = (state: { gradPlanner: GradPlannerState }) =>
  state.gradPlanner.plan.electiveCourses

const filterCoursesFromSelectedCourses = (courses, selectedCourses) => {
  const selectedCourseMap = selectedCourses.reduce((map, c) => {
    map[c.id] = true
    return map
  }, {})
  return courses.filter(c => !selectedCourseMap[c.id])
}
export const selectCoursesForCore = createSelector(
  selectCourses,
  selectCoreCourses,
  filterCoursesFromSelectedCourses
)

export const selectCoursesForPath = createSelector(
  selectCourses,
  selectPathCourses,
  filterCoursesFromSelectedCourses
)

export const selectCoursesForElectives = createSelector(
  selectCourses,
  selectElectiveCourses,
  filterCoursesFromSelectedCourses
)



// WEBPACK FOOTER //
// ./src/redux/reducers/gradPlanner/gradPlannerReducer.js